import React, { FC, forwardRef } from 'react';

import { InputProps } from './Input.types';

const Input: FC<InputProps> = forwardRef(({ type, name, onChange, disabled }, ref) => {
    return <input type={type} id={name} name={name} className="input" ref={ref as null} onChange={onChange} disabled={disabled} />
});

export { Input };